import type { IoTReading, NaveSensores } from './queries/iot';

export const sensorAlertNames: Record<string, string> = {
  TEMPERATURE_LOW: 'Temperatura baja',
  TEMPERATURE_HIGH: 'Temperatura alta',
  HUMIDITY_HIGH: 'Humedad alta',
  AMMONIA_HIGH: 'Amoníaco alto',
  WATER_NO_CONSUMPTION: 'Agua sin variación',
  WATER_STALLED: 'Agua sin variación',
  SILO_LOW: 'Silo bajo',
};
export function hasSensorAlert(reading: IoTReading | null | undefined): reading is IoTReading {
  return !!reading && (reading.state === 'alert' || !!reading.alert_type);
}
export function sensorStationName(index: number) {
  return index < 26 ? String.fromCharCode(65 + index) : String(index + 1);
}
export function sensorAlertLabel(reading: IoTReading) {
  const label = sensorAlertNames[reading.alert_type ?? ''] ?? 'Alerta de sensor';
  const status = reading.state === 'alert' ? label : `Última alerta registrada: ${label}`;
  return `${status}${reading.simulated ? ' · Simulada' : ''}`;
}
/** Describe only the retained readings, including stale values; never label the whole nave. */
export function simulationLabel(
  readings: Array<IoTReading | null | undefined>,
  currentOnly = false,
) {
  const retained = readings.filter(
    (r) => r?.value != null && (!currentOnly || r.state === 'normal' || r.state === 'alert'),
  );
  return !retained.some((r) => r?.simulated)
    ? ''
    : retained.every((r) => r?.simulated)
      ? 'Lecturas simuladas'
      : 'Incluye lecturas simuladas';
}
/** La copia local conserva valores y alertas; su antigüedad nunca la convierte en lectura actual. */
export function currentSensorData(
  data: NaveSensores | undefined,
  now = Date.now(),
): NaveSensores | undefined {
  if (!data) return data;
  const reading = (r: IoTReading | null): IoTReading | null => {
    if (!r || r.state === 'no_data' || r.state === 'disconnected') return r;
    const received = r.received_at ? Date.parse(r.received_at) : NaN;
    return (Number.isFinite(received) ? now - received > 180000 : data.local_snapshot)
      ? { ...r, state: 'disconnected' }
      : r;
  };
  return {
    ...data,
    environment: (data.environment ?? []).map((d) => ({
      ...d,
      temperature: reading(d.temperature),
      humidity: reading(d.humidity),
    })),
    ammonia: reading(data.ammonia),
    water: reading(data.water),
    silo: reading(data.silo),
  };
}
